import { Icon } from '../../icons/Icon'

export function Avatar() {
  return <span className="avatar" aria-hidden="true"><Icon name="person" /></span>
}
